import * as React from 'react';
import clsx from 'clsx';

export interface IconWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export function IconWrapper(props: IconWrapperProps): JSX.Element {
  return (
    <div
      className={clsx(
        'w-fit rounded-full border-8 border-brand-50 bg-brand-100 p-2 text-brand-600',
        'dark:border-gray-900 dark:bg-gray-950 dark:text-gray-200',
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}
